import {
  REFERRAL_UTILITY_REQUEST_QUERY,
  REFERRAL_UTILITY_RESPONSE_QUERY,
  REFERRAL_UTILITY_PUT_QUERY,
  VALIDATE_PATIENT_QUERY,
  GET_PATIENT_ELIGIBILITY_QUERY,
  PRIOR_AUTH_STATUS_QUERY,
} from './queries';
import { BaseInternalApi } from '../baseApi';
import {
  ReferralUtilityResponseInput,
  ReferralUtilityIframeResult,
  ReferralUtilityResponseReferralResult,
  ReferralUtilitySaveResult,
  ReferralUtilitySaveInput,
  ValidatePatientInput,
  ReferralUtilityNoPIIRequestInput,
  ValidatePatientResult,
  PatientEligibilityInput,
  PatientEligibilityResult,
  PriorAuthStatusInput,
  PriorAuthStatusResult,
} from './types';

export class OptumNoPIIApi extends BaseInternalApi {
  constructor() {
    super('optumNoPIIApi', '/optum-referral/api/graphql');
  }

  public async openReferralUtilityIframeNoPII(
    input: ReferralUtilityNoPIIRequestInput,
  ): Promise<ReferralUtilityIframeResult | undefined> {
    const gqlClient = await this.getClient();
    const { numberOfVisits, ...restInput } = input;

    const { data } = await gqlClient.query<
      { referralUtilityRequest: ReferralUtilityIframeResult },
      { input: ReferralUtilityNoPIIRequestInput }
    >({
      query: REFERRAL_UTILITY_REQUEST_QUERY,
      variables: {
        input: { ...(numberOfVisits ? { numberOfVisits: `${numberOfVisits}` } : {}), ...restInput },
      },
      fetchPolicy: 'no-cache',
    });
    return data?.referralUtilityRequest;
  }

  public async getReferralResponseFromOptum(
    input: ReferralUtilityResponseInput,
  ): Promise<ReferralUtilityResponseReferralResult | undefined> {
    const gqlClient = await this.getClient();

    const { data } = await gqlClient.query<
      { referralUtilityResponse: ReferralUtilityResponseReferralResult },
      { input: ReferralUtilityResponseInput }
    >({
      query: REFERRAL_UTILITY_RESPONSE_QUERY,
      variables: { input },
      fetchPolicy: 'no-cache',
    });
    return data?.referralUtilityResponse;
  }

  public async sendReferralSaveInEhr(input: ReferralUtilitySaveInput): Promise<boolean> {
    const gqlClient = await this.getClient();

    const { data } =
      (await gqlClient.query<ReferralUtilitySaveResult, { input: ReferralUtilitySaveInput }>({
        query: REFERRAL_UTILITY_PUT_QUERY,
        variables: { input },
        fetchPolicy: 'no-cache',
      })) ?? {};
    return data?.referralUtilityPut?.isSuccess;
  }

  public async validatePatient(input: ValidatePatientInput): Promise<boolean> {
    const gqlClient = await this.getClient();

    const { data } =
      (await gqlClient.query<ValidatePatientResult, { input: ValidatePatientInput }>({
        query: VALIDATE_PATIENT_QUERY,
        variables: { input },
        fetchPolicy: 'no-cache',
      })) ?? {};
    return data?.validatePatient?.isSuccess;
  }

  public async getPatientEligibility(input: PatientEligibilityInput): Promise<boolean> {
    const gqlClient = await this.getClient();

    const { data } =
      (await gqlClient.query<PatientEligibilityResult, { input: PatientEligibilityInput }>({
        query: GET_PATIENT_ELIGIBILITY_QUERY,
        variables: { input },
        fetchPolicy: 'no-cache',
      })) ?? {};

    return data?.getPatientEligibility?.orderUtilityEnabled;
  }

  public async getPriorAuthStatus(
    input: PriorAuthStatusInput,
  ): Promise<PriorAuthStatusResult | undefined> {
    const gqlClient = await this.getClient();

    const { data } =
      (await gqlClient.query<
        { priorAuthStatus: PriorAuthStatusResult },
        { input: PriorAuthStatusInput }
      >({
        query: PRIOR_AUTH_STATUS_QUERY,
        variables: { input },
        fetchPolicy: 'no-cache',
      })) ?? {};

    return data?.priorAuthStatus;
  }
}
